import { render, staticRenderFns } from "./productSwiper.vue?vue&type=template&id=632492b9&scoped=true&"
import script from "./productSwiper.vue?vue&type=script&lang=js&"
export * from "./productSwiper.vue?vue&type=script&lang=js&"
import style0 from "./productSwiper.vue?vue&type=style&index=0&id=632492b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632492b9",
  null
  
)

export default component.exports